var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStat03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 219.06451612903038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}.cls-1,.cls-2,.cls-3{fill:none;}.cls-2{stroke:#e8ba3a;}.cls-2,.cls-3{stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}.cls-4{clip-path:url(#clippath);}.cls-3{stroke:#193c34;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.709677419350555,
    y: 8.129032258064399,
    width: 234.5806451612989,
    height: 203.22580645161543
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2339"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2341",
    className: "cls-3",
    d: "m143.445831993974934,76.21312157792272h-13.704826230779872"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2353",
    className: "cls-3",
    d: "m140.84107145503549,194.030279725182481c0,2.346085024189961-1.901810629200554,4.247622647279059-4.247622647269964,4.247622647279059-2.346084763950785,0-4.247622647279059-1.901537623089098-4.247622647279059-4.247622647279059,0-2.345812018080323,1.901537883328274-4.247622647280878,4.247622647279059-4.247622647280878,2.34581201806941,0,4.247622647269964,1.901810629200554,4.247622647269964,4.247622647280878Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2365",
    className: "cls-3",
    d: "m165.144373311846721,69.191510249511339h-57.102075428880198c-5.138082480130834,0-9.303290850661142,4.16548111640077-9.303290850661142,9.303562555511235v117.022897188269781c0,5.138357308029299,4.165208370530308,9.303832178340599,9.303290850661142,9.303832178340599h57.102075428880198c5.138354705488382,0,9.303562555509416-4.165483198430593,9.303562555509416-9.303832178340599v-117.022897188269781c0-5.138081439110465-4.165207850021034-9.303562555511235-9.303562555509416-9.303562555511235Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2369",
    className: "cls-3",
    d: "m203.279567662575573,74.119382698652771c-.447276193619473-.278626595390961-1.013262034419313-.278626595390961-1.460538260569592,0-2.183984970410165,1.36065835845875-3.606863480559696,3.576572032709009-3.606863480559696,6.080936846728946,0,2.504091287390111,1.42287877039962,4.720278488270196,3.606863480559696,6.08093684673986.447276161088666.278353816989693,1.013262034419313.278353816989693,1.460538260569592,0,2.184257716280626-1.360658358469664,3.606863480559696-3.576845038838655,3.606863480559696-6.08093684673986,0-2.504364814019937-1.422605764279069-4.720278488270196-3.606863480559696-6.080936846728946Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2373",
    className: "cls-3",
    d: "m223.992988373054686,88.426406826951279c.056216530030724-.743368089038995-.3151946140988-1.452624206009204-.957591297048566-1.830584918978275-3.138028358980591-1.845867015839758-6.848592786371228-2.176343921981243-9.987984679510191-.534056974300256-3.139393454670426,1.642286817548666-4.984441191880251,4.878830763698716-5.257610755299538,8.509162881298835-.055944133870071.743095082920263.315194288779821,1.452624206011023.957590971729587,1.830584918980094,3.138028684288656,1.845867015839758,6.84886533703866,2.176343401470149,9.987985004820075.53405723456126,3.139393714929611-1.642013941560435,4.984442070239311-4.878830503461359,5.257610755308633-8.509163141561658Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2375"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2377",
    className: "cls-3",
    d: "m202.802932802875148,97.709668553381562l11.962932647380512-5.549335366029482"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2381",
    className: "cls-3",
    d: "m181.105586569965453,94.637459069092074c-.055943633700736-.743368089040814.315194614089705-1.452897082010168.957591297039471-1.830584918980094,3.138028358980591-1.845867015839758,6.848865532241689-2.176343921979424,9.987984679510191-.534056974300256,3.139393454670426,1.642286817550485,4.984441191880251,4.878558017840987,5.257610755299538,8.509162881311568.056216879751446.743095082909349-.315194288768907,1.452624205998291-.957590971718673,1.83058491896918-3.13802868429957,1.845867015830663-6.848592591180932,2.176343401470149-9.987985004830989.534057234559441-3.139393714920516-1.642286687429078-4.984442070230216-4.87883050345954-5.257610755299538-8.509163141559839Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2385",
    className: "cls-3",
    d: "m202.295642140144992,103.920720795522357l-11.962932647389607-5.549335366029482"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2387"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2389",
    className: "cls-3",
    d: "m202.549358260515874,86.939346372762884v36.303599647430019"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2391"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2393",
    className: "cls-3",
    d: "m185.863140674195165,123.51592507791247h31.773528091289336"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2397",
    className: "cls-3",
    d: "m185.863140674195165,135.446295824232948h31.773528091289336"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2401",
    className: "cls-3",
    d: "m185.863140674195165,147.376699883021502h31.773528091289336"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2403"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2405",
    className: "cls-2",
    d: "m148.315550662162423,136.850989779206429l-11.032254375362754-15.429023903820053c-.711899999843808-.995300820970442-2.191590542412087-.995300820970442-2.903271481694901,0l-11.032254375360935,15.429023903820053c-7.26255991545986,10.156845733632508-.002411338382444,24.273415110712449,12.483890116209295,24.273415110712449,12.486301106753672,0,19.746450867771273-14.116569377079941,12.483890116209295-24.273415110712449Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2407"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2409",
    className: "cls-2",
    d: "m152.89833772314887,115.286276894707044l-3.816159545905975-5.336837406301129c-.246140041155741-.344333101336815-.757927800839752-.344333101336815-1.004067841995493,0l-3.815940903394221,5.336837406301129c-2.512032664906656,3.513251465452413-.000876242240338,8.395945811647834,4.318084145645116,8.395945811647834,4.318960869526563,0,6.830117228608287-4.882694346195422,4.318084145650573-8.395945811647834Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2411"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2413",
    className: "cls-2",
    d: "m148.316951980854355,143.959377882109038c-1.341606617012076,0-2.54096496303282-.601432545856369-3.346893364074276-1.548513497040403-.426087840327455-.501047625917636-1.203522900481403-.501047625917636-1.629829801369851-.000219165076487-.805708922433041.947300116260521-2.005286224504744,1.54873266211689-3.346893364081552,1.54873266211689-1.341387242911878,0-2.540964544974486-.601432545856369-3.346893364074276-1.548513497040403-.42608784033655-.501047625917636-1.203522900488679-.501047625917636-1.629610740816133-.000219165076487-.805927982994035.947300116260521-2.005505285058462,1.54873266211689-3.34689169185549,1.54873266211689-1.341607139585903,0-2.540965381089336-.601432545856369-3.346892527968521-1.54873266211689-.426306900899363-.500828460841149-1.203522064375647-.500828460841149-1.629828965265915,0-.80571143076304.947300116260521-2.005288732827466,1.54873266211689-3.346895872404275,1.54873266211689-.995300820979537,0-1.912791665277837-.33162079543763-2.650117740111455-.888998025968249-1.598707315699357,8.878801377726631,5.068778767446929,18.053936406227876,15.135541280242251,18.053936406227876,10.066543452234328,0,16.734027863152733-9.175353252954665,15.135322219679438-18.053936301710564-.737323775541881.557377126013307-1.654596186353956.888997921450937-2.650116067899944.888997921450937Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2415"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2417",
    className: "cls-3",
    d: "m207.071318229536701,160.035572767172198h17.914242334649316c2.24565832908047,0,4.066147486790214-1.820487726319698,4.066147486790214-4.066146966290034v-40.688760385699425c0-2.245660411121207-1.820487075679921-4.065874740919753-4.066147486790214-4.065874740919753h-50.537569523050479v48.820782092909212h32.623327188401163"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2421",
    className: "cls-3",
    d: "m163.741935483871202,140.105890199665737v-53.61586844480189h-54.297308038472693v95.0939369794105c0,.4420066520197.34272805092769.801702211027077.763893004519559.801702211027077h52.769775947408561c.420909382111859,0,.763639086544572-.359691520396154.763639086544572-.801702211027077v-41.536230768306268"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1262",
    className: "cls-3",
    d: "m51.286832898314969,191.903733485341945h-11.153875349000373c-7.392119580259532,0-13.384650418809542-5.992531264029822-13.384650418809542-13.384650418800447v-13.607727925778818c0-7.392117878320278,5.99253083855001-13.384650418809542,13.384650418809542-13.384650418809542h26.769300837600895c7.392119580259532,0,13.384650418800447,5.992532540489265,13.384650418800447,13.384650418809542"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1266",
    className: "cls-3",
    d: "m55.748383037915119,178.519083066541498h-15.615425488600522v-13.607727925778818"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1270",
    className: "cls-3",
    d: "m66.902258386915491,131.449729093752467c0,7.392119154779721-5.992530838539096,13.384650418800447-13.384650418789533,13.384650418800447-7.392119580270446,0-13.384650418811361-5.992531264020727-13.384650418811361-13.384650418800447"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1274",
    className: "cls-2",
    d: "m78.056133735924959,191.903733485341945l-4.461550139609244,13.384650418800447h-26.769300837599076l13.384650418798628-40.377028763379712h26.76930083760999l-4.57554267418891,13.94948300004944"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1278",
    className: "cls-3",
    d: "m80.286908805715939,191.903733485341945h-6.692325209400224v-13.384650418800447h6.692325209400224c3.695948312650216,0,6.692325209409319,2.996376896750007,6.692325209409319,6.692325209400224,0,3.695948099901216-2.996376896759102,6.692325209400224-6.692325209409319,6.692325209400224Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1282",
    className: "cls-3",
    d: "m46.825282758716639,205.288383904142393h-13.384650418811361v-13.384650418800447"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m68.701167273975443,121.630801606992463c0-8.473853133269586-6.869415237510111-15.343268370779697-15.343268370768783-15.343268370779697-8.4738531332805,0-15.343268370790611,6.869415237510111-15.343268370790611,15.343268370779697"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 29.99999999999818,
    y1: 123.51592507791247,
    x2: 74.93304863820595,
    y2: 123.51592507791247
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1254",
    className: "cls-3",
    d: "m20.948291949014674,54.002126193641743v26.992378344590179c0,3.696171267611135,2.996377109520836,6.692325209400224,6.692325209420233,6.692325209400224h6.915402716371318v13.384650418800447l13.384650418800447-13.384650418800447h20.30005313519905c3.695946610700048,0,6.692325209400224-2.996153941789089,6.692325209400224-6.692325209400224v-26.992378344590179c0-3.696171267609316-2.996378598700176-6.692325209400224-6.692325209400224-6.692325209400224H27.640617158434907c-3.695948099899397,0-6.692325209420233,2.996153941790908-6.692325209420233,6.692325209400224Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1256"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1258",
    className: "cls-2",
    d: "m39.575263781865942,69.282935421782895l5.019243907048804,5.019243907039709,10.038487814101245-10.038487814099426"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStat03);
export default __webpack_public_path__ + "static/media/stat03.5adbdbe372f402503a049ae316295a38.svg";
export { ForwardRef as ReactComponent };